import { type LensListItemModel } from "../../../lenses/models";
import { type GetGroupDetailsQuery } from "../../api/queries/getGroupV2.gql-generated";
import { GroupDetailsModelV2, type LensUpdateData } from "../models";

export type GroupDetailsActionV2 =
    | {
          type: "addLenses";
          lenses: LensListItemModel[];
      }
    | { type: "removeLens"; lensId: string }
    | { type: "changeLens"; updatedLens: LensUpdateData }
    | { type: "filter"; lensName: string }
    | { type: "initialize"; group: GetGroupDetailsQuery["getGroupV2"] }
    | { type: "changeName"; name: string }
    | { type: "changeDescription"; description: string };

export const groupDetailsReducerV2 = (state: GroupDetailsModelV2, action: GroupDetailsActionV2) => {
    switch (action.type) {
        case "initialize":
            return action.group && GroupDetailsModelV2.createFromGroupWithConnections(action.group);
        case "addLenses":
            return state.addLenses(action.lenses);
        case "removeLens":
            return state.removeLens(action.lensId);
        case "changeLens":
            return state.updateLens(action.updatedLens);
        case "filter":
            return state.filterByName(action.lensName);
        case "changeName":
            return state.updateName(action.name);
        case "changeDescription":
            return state.updateDescription(action.description);
        default:
            return state;
    }
};
